module.exports = require("protobufjs/minimal");